import styled from "styled-components";
import { satoshi900 } from "../../styles/font.constants";
import { spacing } from "../../styles/styles.constants";

export const Card = styled.div<{ $isViewer: boolean; $borderColour: string }>`
	border-radius: ${spacing.borderRadius};
	background-color: #fdfdfd;
	width: 100%;
	flex: 1;
	min-height: 0;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	border: solid 1px ${({ $borderColour }) => $borderColour};
	padding-bottom: ${({ $isViewer }) => ($isViewer ? "1rem" : spacing.padding)};
`;

export const StickyHeader = styled.div<{ $isViewer: boolean }>`
	flex-shrink: 0;
	padding: ${({ $isViewer }) => ($isViewer ? "0.8rem" : spacing.padding)};
`;

export const ScrollBody = styled.div`
	flex: 1;
	min-height: 0;
	overflow-y: auto;
	padding: 0 ${spacing.padding};
`;

export const Title = styled.div`
	${satoshi900}
	font-size: 1.25rem;
	letter-spacing: 2%;
	margin-bottom: 1rem;
`;
